import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { fonts } from 'bench-style-constants';
const weightMap = {
  normal: '300',
  medium: '600',
  bold: '700',
};
const StyledHeading = styled.div<HeadingProps>`
  display: block;
  font-family: ${fonts.circular};
  font-weight: ${({ weight = 'medium' }) => weightMap[weight]};

  ${props =>
    props.size === 1 &&
    css`
      font-size: 32px;
      line-height: 40px;
    `}

  ${props =>
    props.size === 2 &&
    css`
      font-size: 24px;
      line-height: 32px;
    `}

  ${props =>
    props.size === 3 &&
    css`
      font-size: 20px;
      line-height: 24px;
    `}

  ${props =>
    props.size === 4 &&
    css`
      font-size: 16px;
      line-height: 24px;
    `}

  ${props =>
    props.size === 5 &&
    css`
      font-size: 12px;
      line-height: 16px;
    `}

  ${props =>
    props.size === 6 &&
    css`
      font-size: 10px;
      line-height: 16px;
    `}

  ${props =>
    props.size === 7 &&
    css`
      font-size: 8px;
      line-height: 16px;
    `}
`;
type HeadingProps = {
  children: ReactNode;
  size: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  weight?: 'normal' | 'medium' | 'bold';
};

const Heading = (props: HeadingProps) => <StyledHeading {...props}>{props.children}</StyledHeading>;

Heading.defaultProps = {
  weight: 'medium',
};
export default Heading;
